module.exports = __webpack_public_path__ + "img/gambar-erd.5348d8ab.png";